import {defaultKeyMap} from "~common/components/app-view/key-mapping-default";

export const keyMap = defaultKeyMap